<script>
import debounce from 'debounce';
import { payments } from 'pando-payment-request-computation';
import { getSystemCharges, getTransporterCharges } from '@common/lib/payments';
import editableType from '@common/constants/editableConstants';

const ChargeMixin = {
  data() {
    return {
      pay: {},
    };
  },
  created() {
    this.pay = new payments();
  },
  computed: {
    systemCharges() {
      return getSystemCharges(this.charges);
      return val;
    },
    discrepancy() {
      return this.discrepancyCharges && this.discrepancyCharges[0];
    },
    total() {
      return this.transporterCharges.total_amount || 0;
    },
  },
  methods: {
    updateChargeObj(value,actualChargeObj,chargesBy) {
      const charges = Object.assign({ id: actualChargeObj && actualChargeObj.id ,
       charges_by: chargesBy},value);
      return charges;
    },
    async calculateTotal() {
      let resultTotal = {};
      let totalWithoutCustom = 0;
      const result = {
        additionalPoint: this.transporterCharges.additional_point_charges,
        arrivalDelay: this.transporterCharges.arrival_charge,
        cartonDamage: this.transporterCharges.carton_damage_charge,
        freight: this.transporterCharges.contract_charge,
        damage: this.transporterCharges.damage_charge,
        fixedCharge: this.transporterCharges.fixed_charge,
        loading: this.transporterCharges.loading_charge,
        loadingDetention: this.transporterCharges.loading_detention_charge,
        oda: this.transporterCharges.oda_charge,
        shortage: this.transporterCharges.shortage_charge,
        transitDelay: this.transporterCharges.transit_charge,
        unloading: this.transporterCharges.unloading_charge,
        unloadingDetention: this.transporterCharges.unloading_detention_charge,
        extraCharge: this.transporterCharges.extra_charges,
        leakage: this.transporterCharges.leakage_charge,
        lrCharge: this.transporterCharges.lr_charge,
        extra_km_charge: this.transporterCharges.extra_km_charge,
        bdr: this.transporterCharges.bdr_charge,
        deductible: this.transporterCharges.deductible_charge,
        hillyRegionCharge: this.transporterCharges.hilly_region_additional_charge,
        returnFreightCharge: this.transporterCharges.return_freight_charge,
        rtoCharges: this.transporterCharges.rto_charges,
        mallCharge: this.transporterCharges.mall_charge,
        appointmentCharge: this.transporterCharges.appointment_charge,
        ecc: this.transporterCharges.ecc,
        rovCharge: this.transporterCharges.rov_charge,
        transporterDebit: this.transporterCharges.transporter_debit,
      };
      resultTotal.totalWithoutCustom = this.pay.getPaymentChargesTotal([Object.assign({}, result)]);      
      Object.keys(this.transporterCharges).map(charge => {
        if (charge.includes('custom')) {
          if (!result.custom_charges) result.custom_charges = {};
          result.custom_charges[charge] = this.transporterCharges[charge];
        }
      });
      resultTotal.totalWithCustom = this.pay.getPaymentChargesTotal([result]);
      return resultTotal;
    },
    totalCompute: debounce(async function(event) {
      const resultTotal = await this.calculateTotal();
      let total_amount = resultTotal.totalWithCustom && resultTotal.totalWithCustom[0].totalAmount;
      total_amount = Number(total_amount.toFixed(3));
      const value = Object.assign(this.tempCharge,{total_amount});
      this.$store.commit('paymentsV2/updateTempCharges',{index:this.index,value });
    },300),
    canEditCharge(settings, header) {
      const config = settings[header.column];
      const charge = header;
      switch (config) {
        case editableType.NON_EDITABLE:
          charge.readOnly = true;
          delete charge.action;
          break;
        case editableType.EDITABLE:
          charge.readOnly = false;
          delete charge.action;
          break;
        case editableType.INCREMENT_ONLY:
          charge.readOnly = false;
          charge.action = 'incrementOnly';
          break;
        case editableType.DECREMENT_ONLY:
          charge.readOnly = false;
          charge.action = 'decrementOnly';
          break;
        default:
          return charge;
      }
      return charge;
    },
  },
};
export default ChargeMixin;
</script>
